// 1. Import `extendTheme`
import { extendTheme, withDefaultColorScheme } from '@chakra-ui/react';

// 2. Call `extendTheme` and pass your custom values
const theme = extendTheme(
	withDefaultColorScheme({
		colorScheme: 'brand',
		components: ['Button', 'Badge'],
	}),

	{
		config: {
			cssVarPrefix: 'poc',
		},

		styles: {
			global: {
				'html,body': {
					fontSize: 14,
				},
				'*:focus': {
					boxShadow: 'none !important',
				},
				'*[data-focus]': {
					boxShadow: 'none !important',
				},
			},
		},

		colors: {
			primary: '#255AA5', // brand Color
			warning: '#FDB849',
			success: '#1ED760',
			info: '#143E9F',
			green: {
				50: '#1ED760',
				100: '#1ED760',
				500: '#1ED760',
			},
			yellow: {
				50: '#FDB849',
				100: '#FDB849',
				500: '#FDB849',
			},

			danger: {
				50: '#FF4847',
				100: '#FF3350',
				500: '#FF3350',
			},
			red: {
				50: '#FF4847',
				100: '#FF3350',
				500: '#FF3350',
			},
			white: '#ffffff',
			brand: {
				50: '#255AA5',
				100: '#255AA5',
				500: '#255AA5',
			},
			teal: {
				50: '#292AA3',

				100: '#292AA3',
				200: '#292AA3',
				300: '#292AA3',

				500: '#255AA5',
				600: '#255AA5',
				700: '#255AA5',
				800: '#255AA5',
			},
			//common

			background: '#ffffff',
			text: 'black',
			gray: {
				900: '#1D2530',
				800: '#343C46',
				700: '#474F5C',
				600: '#636972',
				500: '#91979F',
				400: '#AFB4BB',
				300: '#CBD0D6',
				200: '#DFE5EC',
				100: '#EEF1F7',
			},
		},
		fonts: {
			body: 'Inter, sans-serif',
			heading: 'Inter, serif',
			mono: 'Inter, monospace',
		},

		space: {
			sm1: '4px',
			sm2: '8px',
			rg1: '12px',
			rg2: '16px',
			lg1: '20px',
			lg2: '24px',
			ma1: '32px',
			ma2: '48px',
			ma3: '64px',
		},
	}
);
export default theme;
